import { Application } from '@hotwired/stimulus';

const stimulusApp = Application.start();

// Configure Stimulus development experience
stimulusApp.debug = false;

// Make stimulusApp globally available for non-module scripts
window.stimulusApp = stimulusApp;

export { stimulusApp };
